var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { useCallback, useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
const DEFAULT_MESSAGE = 'Les modifications que vous avez apportées ne seront peut-être pas enregistrées.';

const useBrowserNavigationPrompt = isBlocked => {
  const beforeUnload = useCallback(e => {
    if (isBlocked) {
      const confirmationMessage = 'o/';
      e.returnValue = confirmationMessage;
      return confirmationMessage;
    }

    return null;
  }, [isBlocked]);
  useEffect(() => {
    window.addEventListener('beforeunload', beforeUnload);
    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [beforeUnload]);
};

const useReactRouterPrompt = (isBlocked, message) => {
  const {
    navigator
  } = useContext(UNSAFE_NavigationContext);
  const displayAlert = useCallback(transition => __awaiter(void 0, void 0, void 0, function* () {
    const confirmation = window.confirm(message);

    if (confirmation) {
      transition === null || transition === void 0 ? void 0 : transition.retry();
    }
  }), [message]);
  useEffect(() => {
    if (!isBlocked) {
      return;
    }

    const {
      block,
      location: {
        pathname
      }
    } = navigator;
    const unblock = block(transitionBlock => {
      const {
        location: {
          pathname: targetPathname
        }
      } = transitionBlock; // We don't show the alert if the user is navigating to the same page

      if (targetPathname === pathname) {
        return;
      }

      displayAlert(Object.assign(Object.assign({}, transitionBlock), {
        retry() {
          unblock();
          transitionBlock.retry();
        }

      }));
    });
    return unblock;
  }, [displayAlert, isBlocked, navigator]);
};

export const useNavigationPrompt = function (isBlocked) {
  let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_MESSAGE;
  useBrowserNavigationPrompt(isBlocked);
  useReactRouterPrompt(isBlocked, message);
};